"use strict";
var $ = require("../internals/export");
var fill = require("../internals/array-fill");
var addToUnscopables = require("../internals/add-to-unscopables");
$({ target: "Array", proto: true }, {
  fill
});
addToUnscopables("fill");
